<h3 mat-dialog-title class="title primary">
  <span class="material-symbols-outlined puntatore" (click)="onNoClick()">
    clear
  </span>
</h3>
<div mat-dialog-content>
  <div class="row">
    <div class="col-12 col-md-12">
      <div class="wrapper" *ngIf="inserito">
        <div
          [innerHTML]="
            'carrello_sconto.dialog_inserito'
              | translate
                : { codice: codice.codice, cantina: carrello.denominazione }
          "
        ></div>
      </div>
      <div class="wrapper" *ngIf="!errore && !inserito">
        <div
          [innerHTML]="
            'carrello_sconto.dialog_mancanza_title'
              | translate
                : { codice: codice.codice, cantina: carrello.denominazione }
          "
        ></div>
        <span class="material-symbols-outlined arrow"> arrow_downward </span>
        <div>
          <div
            [innerHTML]="'carrello_sconto.dialog_mancanza_subtitle' | translate"
          ></div>
          <div
            *ngIf="codice.tipo_codice === '0'"
            [innerHTML]="
              'carrello_sconto.dialog_mancanza_1'
                | translate
                  : {
                      minimo: codice.minimo_totale | number : '1.2-2',
                      totale: carrello.totale_abilitati | number : '1.2-2'
                    }
            "
          ></div>
          <div
            *ngIf="codice.tipo_codice === '1'"
            [innerHTML]="
              'carrello_sconto.dialog_mancanza_2'
                | translate
                  : {
                      minimo: codice.minimo_bottiglie,
                      qta: carrello.qta_abilitati
                    }
            "
          ></div>
        </div>
      </div>
      <div class="wrapper" *ngIf="errore">
        <div
          [innerHTML]="'carrello_sconto.dialog_problema_title' | translate"
        ></div>
        <span class="material-symbols-outlined arrow"> arrow_downward </span>
        <div
          *ngIf="tipo_errore === 'cumulabili'"
          [innerHTML]="
            'carrello_sconto.dialog_cumulabili'
              | translate : { cantina: carrello.denominazione }
          "
        ></div>
        <div
          *ngIf="tipo_errore === 'no-active'"
          [innerHTML]="
            'carrello_sconto.dialog_attivo'
              | translate : { codice: codice.codice }
          "
        ></div>
        <div
          *ngIf="tipo_errore === 're-insert'"
          [innerHTML]="
            'carrello_sconto.dialog_utilizzato'
              | translate : { codice: codice.codice }
          "
        ></div>
        <div
          *ngIf="tipo_errore === 'no-exist'"
          [innerHTML]="
            'carrello_sconto.dialog_errato'
              | translate : { codice: codice.codice }
          "
        ></div>
      </div>
    </div>
  </div>
</div>
